import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ breaks: true, gfm: true });

/** Converts markdown to sanitized HTML safe for dangerouslySetInnerHTML. */
export function markdownToSafeHtml(markdown: string): string {
  if (!markdown || !markdown.trim()) return '';
  const rawHtml = marked.parse(markdown, { async: false }) as string;
  return DOMPurify.sanitize(rawHtml, { USE_PROFILES: { html: true } });
}

/** Converts markdown to plain text (all tags stripped) for compact previews. */
export function markdownToPlainText(markdown: string): string {
  if (!markdown || !markdown.trim()) return '';
  const rawHtml = marked.parse(markdown, { async: false }) as string;
  const text = DOMPurify.sanitize(rawHtml, { ALLOWED_TAGS: [] });
  return text.replace(/\s+/g, ' ').trim();
}
